import React from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import 'react-select/dist/react-select.css';
import i18n from '../utils/i18n';
import './styles/SelectAreaComponent.scss';

class SelectAreaComponent extends React.Component {
  constructor(props) {
    super(props);

    this.onChange = this.onChange.bind(this);
  }

  onChange(newValue) {
    this.props.notifyChange(newValue);
  }

  render() {
    return (
      <div className="select-area-component">
        <Select
          options={ this.props.availableAreas.map(area => ({
            value: area.id,
            label: area.name
          })) }
          onBlurResetsInput={ false }
          onSelectResetsInput={ false }
          simpleValue
          value={ this.props.selectedValue }
          onChange={ this.onChange }
          className="select-box"
          placeholder={ i18n.t('FILTER_BY_AREA_PLACEHOLDER') }
          disabled={ this.props.disabled }
        />
      </div>
    );
  }
}

SelectAreaComponent.propTypes = {
  selectedValue: PropTypes.number,
  availableAreas: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      description: PropTypes.string
    })
  ).isRequired,
  notifyChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool
};

SelectAreaComponent.defaultProps = {
  selectedValue: 0,
  disabled: false
};

export default SelectAreaComponent;



// WEBPACK FOOTER //
// ./src/components/SelectAreaComponent.js